import { render, staticRenderFns } from "./ProgramListDirection.vue?vue&type=template&id=1aefb7e8&scoped=true"
import script from "./ProgramListDirection.vue?vue&type=script&lang=js"
export * from "./ProgramListDirection.vue?vue&type=script&lang=js"
import style0 from "./ProgramListDirection.vue?vue&type=style&index=0&id=1aefb7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aefb7e8",
  null
  
)

export default component.exports